import React from "react";
import OverviewCard from "./OverviewCard";
const OverviewCards = ({ data }) => {
  if (!data) return null;

  const cards = [
    { data: data.card1, icon: "🏦", color: "bg-blue-800 text-blue-100" },
    { data: data.card2, icon: "📈", color: "bg-emerald-800 text-emerald-100" },
    { data: data.card3, icon: "📉", color: "bg-red-800 text-red-100" },
    { data: data.card4, icon: "💰", color: "bg-yellow-800 text-yellow-100" },
    { data: data.card5, icon: "📄", color: "bg-indigo-800 text-indigo-100" },
    { data: data.card6, icon: "⚖️", color: "bg-slate-800 text-slate-100" },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {cards.map(({ data: cardData, icon, color }, index) => {
        if (!cardData || !cardData[0]) return null;
        const item = cardData[0];
        const title = Object.keys(item).find((k) => k !== "Value");
        const value = item.Value;
        return (
          <OverviewCard
            key={index}
            title={title}
            value={value}
            icon={icon}
            colorClass={color}
          />
        );
      })}
    </div>
  );
};

export default OverviewCards;
